import React, { useCallback } from 'react';
import Icon from 'flow/components/ui-components/Icon';
import ContextMenu from 'flow/components/ContextMenu';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';
import {
    admitAllWaitingParticipants,
    denyAllWaitingParticipants,
} from 'flow/actions/meeting-actions';

/**
 * ⋮ menu beside the "Asking to join" heading, holding the batch verdicts
 * (VID-76). Allow leads here, unlike the per-row buttons where Deny comes
 * first — that is what the design asks for, and it puts the destructive
 * batch action furthest from the pointer's resting place.
 */
const MeetingWaitingSectionMenu = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const allowAll = useCallback(
        () => dispatch(admitAllWaitingParticipants()),
        [dispatch],
    );
    const denyAll = useCallback(
        () => dispatch(denyAllWaitingParticipants()),
        [dispatch],
    );

    return (
        <ContextMenu
            triggerLabel={i18next.t(
                'videoconference.waiting_participants_menu',
            )}
            className="flex size-8 shrink-0 items-center justify-center !rounded-xl !bg-transparent !p-0 hover:!bg-gray-700"
            menuClassName="no-dark min-w-[180px] !bg-gray-700 text-white"
            placement="bottom-end"
            icon={<Icon iconKey="more_vert" className="text-white" />}
            dataTestId="waiting-section-menu"
        >
            <MenuItem
                onClick={allowAll}
                closeOnClick={true}
                className="!bg-gray-700 !text-white hover:!bg-gray-600"
                dataTestId="waiting-section-allow-all"
            >
                <div>{i18next.t('videoconference.waiting_room.allow_all')}</div>
            </MenuItem>
            <MenuItem
                onClick={denyAll}
                closeOnClick={true}
                className="!bg-gray-700 !text-white hover:!bg-gray-600"
                dataTestId="waiting-section-deny-all"
            >
                <div>{i18next.t('videoconference.waiting_room.deny_all')}</div>
            </MenuItem>
        </ContextMenu>
    );
};

export default MeetingWaitingSectionMenu;
